// import { dismissModal } from '../../services/dialog/actions'
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Button, { TYPES } from '../Button/index'
import { H2, HEADING_TYPES } from '../Heading/index'
import Loading, { LOADING_ICON_BLUE_DARK_BG_WHITE } from '../Loading/index'

export default function ModalConfirm ({
  confirmMessage,
  confirmButtonText,
  cancelButtonText,
  processing,
  onConfirm,
  onCancel,
}) {
  const onClose = useCallback(() => {
    onCancel()
  }, [])

  const onContinue = useCallback(() => {
    onConfirm()
  }, [onConfirm])

  return (
    <div className="modal-confirm">
      <div className="modal-confirm__wrapper">
        <H2 as={HEADING_TYPES.H6}>{confirmMessage}</H2>
        {processing ? (
          <div className="modal-confirm__processing">
            <Loading visible icon={LOADING_ICON_BLUE_DARK_BG_WHITE} />
          </div>
        ) : <div className="modal-confirm__buttons">
            <Button
              className="modal-confirm__cancel button--stacked"
              type={TYPES.SECONDARY}
              onClick={onClose}
            >
              {cancelButtonText || 'Cancel'}
            </Button>
            <Button
              className="modal-confirm__continue button--stacked"
              type={TYPES.PRIMARY}
              onClick={onContinue}
            >
              {confirmButtonText || 'Confirm'}
            </Button>
          </div>
        }
      </div>
    </div>
  )
}

ModalConfirm.propTypes = {
  confirmMessage: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  processing: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
}
